import { createSlice } from '@reduxjs/toolkit'

export const slice = createSlice({
  name: 'contacts',
  initialState: {
    contacts: {},
    contactsCount: 0,
    currentlyEditedContact: {},
  },
  reducers: {
    setCurrentlyEditedContact: (state, action) => {
      state.currentlyEditedContact = action.payload
    },
    incrementCountContacts: (state) => {
      state.contactsCount += 1
    },
    decrementCountContacts: (state) => {
      state.contactsCount -= 1
    },
    incrementByAmountCountContacts: (state, action) => {
      state.contactsCount += action.payload
    },
    addContact: (state, action) => {
      const contact = action.payload
      state.contacts[contact.id] = contact
    },
    addContacts: (state, action) => {
      const contacts = action.payload
      for (const newContact of contacts) {
        state.contacts[newContact.id] = newContact
      }
    },
    removeContact: (state, action) => {
      // eslint-disable-next-line
      const { id } = action.payload
      if (id !== undefined) {
        const contactToDelete = Object.values(state.contacts).find(contact => contact.id === id)
        delete state.contacts[contactToDelete?.id]
        state.contactsCount = state.contactsCount - 1
        return state
      } else {
        throw new Error('Cannot delete contact with id: undefined')
      }
    },
    editContact: (state, action) => {
      const editedContact = action.payload
      state.contacts[editedContact.id] = editedContact
    },
    _saveCurrentContactData: (state, action) => {
      state.currentlyEditedContact = action.payload
    }
  },
})

export const { addContact, addContacts, editContact, removeContact, incrementCountContacts, incrementByAmountCountContacts, decrementCountContacts } = slice.actions
export const selectCount = state => state.counter.value
export default slice.reducer
